import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { notifyWhatsAppOpener } from '../utils/whatsappOAuth';
import './WixProductEntry.css';
import './WixOnboarding.css';

const MESSAGES = { cancelled:'wix_whatsapp_cancelled', incomplete:'wix_whatsapp_incomplete', error:'wix_whatsapp_connect_error' };

// Landing page of Meta's signup popup. It needs no Wix grant or portal login:
// the onboarding window confirms the number through its authenticated status request.
export default function WhatsAppOAuthReturn({result}) {
  const {t} = useTranslation();
  useEffect(() => {
    delete window.__UB_WIX_CALLBACK__;
    window.history.replaceState(window.history.state, '', window.location.pathname);
    let timer;
    try {
      if (notifyWhatsAppOpener(result)) timer = setTimeout(() => window.close(), 300);
    } catch { /* The original page also polls when the provider severs opener. */ }
    return () => clearTimeout(timer);
  }, [result]);
  return <main className="wxo-scope wxo-wrapper wix-product-entry">
    <img className="wxo-logo" src="/ultimo-bots-white.png" alt="Ultimo Bots" />
    <div className="wxo-stage"><section className="wxo-card wix-product-card">
      <h1 className="wxo-h2">{t('wix_whatsapp_return_title')}</h1>
      <p className="wxo-sub">{t(MESSAGES[result] || 'wix_whatsapp_return_help')}</p>
      <p>{t('wix_whatsapp_return_tab')}</p>
      <button className="wxo-btn" onClick={() => window.close()}>{t('close')}</button>
    </section></div>
  </main>;
}
